import { useState, type FormEvent } from "react";
import { ErroreApi } from "../api";
import { useSessione } from "../sessione";
import { AvvisoDemo } from "../componenti/AvvisoDemo";
import { CampoPassword } from "../componenti/CampoPassword";
import { Sigla } from "../componenti/Marchio";

export function Entra() {
  const { entra, completaAccesso, sessioneScaduta } = useSessione();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Il gettone dice che la password era giusta e che ora serve il codice. Fino
  // a quando c'e' si vede il secondo passaggio; non e' una sessione, da solo
  // non apre niente.
  const [gettone, setGettone] = useState<string | null>(null);
  const [codice, setCodice] = useState("");
  const [errore, setErrore] = useState<string | null>(null);
  const [inCorso, setInCorso] = useState(false);

  async function invia(evento: FormEvent) {
    evento.preventDefault();
    setErrore(null);
    setInCorso(true);
    try {
      const daRiportare = await entra(email, password);
      if (daRiportare !== null) {
        setGettone(daRiportare);
        setPassword("");
        setInCorso(false);
      }
    } catch (e) {
      // Il backend dice "Credenziali non valide" tanto per un'email che non
      // esiste quanto per una password sbagliata, apposta: distinguere le due
      // cose direbbe a chiunque provi quali indirizzi sono veri. Qui non si
      // aggiunge nessun dettaglio in piu'.
      setErrore(
        e instanceof ErroreApi ? e.message : "Accesso non riuscito. Riprova.",
      );
      setInCorso(false);
    }
  }

  function ricomincia() {
    setGettone(null);
    setCodice("");
    setErrore(null);
    setInCorso(false);
  }

  async function inviaCodice(evento: FormEvent) {
    evento.preventDefault();
    if (gettone === null) return;
    setErrore(null);
    setInCorso(true);
    try {
      await completaAccesso(gettone, codice);
    } catch (e) {
      // Il gettone vale cinque minuti: scaduto, non c'e' nulla da riprovare col
      // codice, si riparte dalla password.
      if (e instanceof ErroreApi && e.stato === 401 && /scaduto/i.test(e.message)) {
        ricomincia();
        setErrore("Il tempo per inserire il codice è scaduto. Accedi di nuovo.");
        return;
      }
      setErrore(e instanceof ErroreApi ? e.message : "Accesso non riuscito. Riprova.");
      setCodice("");
      setInCorso(false);
    }
  }

  return (
    <main className="portineria">
      <div className="portineria-foglio">
        <Sigla bicolore className="accesso-sigla" />
        <p className="accesso-studio">Studio Ceruzzi</p>
        <h1>{gettone === null ? "Fatturazione" : "Codice di verifica"}</h1>
        <AvvisoDemo />

        {gettone === null ? (
          <form className="modulo" onSubmit={invia} noValidate>
            {sessioneScaduta && (
              <p className="aiuto" role="status">
                Per sicurezza la sessione è scaduta. Accedi di nuovo.
              </p>
            )}
            <div className="campo">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                autoComplete="username"
                autoFocus
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="campo">
              <label htmlFor="password">Password</label>
              <CampoPassword
                id="password"
                value={password}
                autoComplete="current-password"
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {errore && (
              <p className="errore" role="alert">
                {errore}
              </p>
            )}

            <div>
              <button
                className="tasto tasto-principale"
                type="submit"
                disabled={inCorso}
              >
                {inCorso ? "Accesso in corso…" : "Accedi"}
              </button>
            </div>

            <p className="aiuto">
              Password dimenticata? Chiedi a un amministratore dello studio di
              reimpostarla.
            </p>
          </form>
        ) : (
          <form className="modulo" onSubmit={inviaCodice} noValidate>
            <p className="aiuto">
              Scrivi il codice di 6 cifre che l'app di autenticazione mostra sul
              telefono.
            </p>

            <div className="campo">
              <label htmlFor="codice">Codice</label>
              <input
                id="codice"
                value={codice}
                autoComplete="one-time-code"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck={false}
                autoFocus
                required
                onChange={(e) => setCodice(e.target.value)}
              />
            </div>

            {errore && (
              <p className="errore" role="alert">
                {errore}
              </p>
            )}

            <div>
              <button
                className="tasto tasto-principale"
                type="submit"
                disabled={inCorso}
              >
                {inCorso ? "Verifica in corso…" : "Accedi"}
              </button>
              <button className="tasto tasto-nudo" type="button" onClick={ricomincia}>
                Indietro
              </button>
            </div>

            <p className="aiuto">
              Telefono perso? Scrivi qui uno dei codici di recupero che hai
              conservato.
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
